<template>
<div class="settings_right">
    <!-- <div class="content-header index">
      <div class="content-header-left d-flex">
        <div class="search padr20">
           <vs-input icon-pack="feather"  icon="icon-search" placeholder="Search" class="is-label-placeholder" v-model.lazy="searchtxt"  /> 

         </div>
         <div class="search w-250">
          <multiselect @input="changedstatus()"  v-model="selected_status_obj" :options="reminderstatus_list"  :multiple="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Select Status" label="name" track-by="name" :preselect-first="false">
            <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
          </multiselect>
        </div>

      </div>
    </div>-->

    <!-- <div class="accordian-table custom-table pad30">
        <div calss="quickbooks-page" >
           
            <quickbooksConfig />
            <div class="table_footer"></div>
        </div>
    </div> -->
    <div class="pad20 pb-0"  v-if="[1,3,50].indexOf(getUserRoleId)>-1">
      <div class="quickbooksConfig_page">
        <div class="form_section pad0 marb15">
            <globalConfig />
        </div>
      </div>
    </div>
    <div class="pad20 pt-0" v-if="[3, 4].indexOf(getUserRoleId) > -1 && getTenantTypeId != 2">
      <div class="quickbooksConfig_page">
        <div class="form_section pt-0 pb-0">
            <quickbooksConfig />
        </div>
      </div>
    </div>
     <!-- <div class="pad20 pt-0"  v-if="[3,50].indexOf(getUserRoleId)>-1">
      <div class="quickbooksConfig_page">
        <div class="form_section pt-0">
            <globalConfig />
        </div>
      </div>
    </div> -->
</div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import Paginate from "vuejs-paginate";
import Datepicker from "vuejs-datepicker-inv";
import Multiselect from "vue-multiselect-inv";
import JQuery from "jquery";

import quickbooksConfig from "@/views/settings/quickbooksConfig";
import globalConfig from "@/views/settings/globalConfig.vue";

import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
export default {
    components: {
        Datepicker,
        DateRangePicker,
        Multiselect,
        Paginate,
        quickbooksConfig,
        globalConfig,
    },
    data: () => ({
        
    }),
    watch: {},
    methods: {
       
    },

    mounted() {
    },
};
</script>
